<template>
  <form class="justify-content-between col-lg-12 py-3">
    <div class="form-row align-items-center py-3">
      <NumberInputField
          class="form-group col-lg-3 col-md-12"
          v-model="partTimePercentage.percentage"
          labelText="percentage"
          @input="verifyPercentage"
          required
          minValue="0" maxValue="100"/>
      <DateInputField
          class="form-group col-lg-3 col-md-12"
          v-model="partTimePercentage.startDate"
          @input="verifyDates"
          labelText="startDatum"
          required/>
      <DateInputField
          class="form-group col-lg-3 col-md-12"
          v-model="partTimePercentage.endDate"
          @input="verifyDates"
          labelText="einddatum"
          :after-date="startDateFormatted()"/>
      <div class="form-group col-lg-3 col-md-12">
        <button
            type="button"
            class="btn-basic btn-fill-pulse mr-2 mt-4"
            :disabled="isDateWrong || isPercentageWrong || alreadyHaveAnotherNullEndDate() || isFullyOverlappingAnotherRecord()"
            @click="createPartTimePercentage">
          Opslaan
        </button>
      </div>
      <div v-if="alreadyHaveAnotherNullEndDate()" class="pl-3 col-lg-8">
        <span class="text-red">Een nieuw deeltijds percentage tussen twee reeds bestaande periodes moet een einddatum hebben.</span>
      </div>
      <div v-if="isFullyOverlappingAnotherRecord()" class="pl-3 col-lg-8">
      <span class="text-red">Een nieuw deeltijds percentage mag een reeds bestaande periode niet volledig overlappen.</span>
    </div>
    </div>
  </form>
</template>
<script>

import DateInputField from "@/components/inputFields/DateInputField";
import NumberInputField from "@/components/inputFields/NumberInputField.vue";
import {mapActions} from "vuex";
import {toYearAndMonthAndDay} from "@/util/DateUtil";

export default {
  name: "CreatePartTimePercentageRecordComponent",
  components: {
    NumberInputField,
    DateInputField
  },
  props: ['partTimePercentageRecords'],
  data: () => ({
    isDateWrong: true,
    isPercentageWrong: true,
    partTimePercentage: {
      startDate: undefined,
      endDate: undefined,
      percentage: undefined
    },
  }),
  methods: {
    ...mapActions("administrationUser", ["createPartTimePercentageRecord"]),
    startDateFormatted() {
      return toYearAndMonthAndDay(this.partTimePercentage.startDate);
    },
    alreadyHaveAnotherNullEndDate() {
      if (this.partTimePercentage.endDate != null) {
        return false;
      }
      for (let record of this.partTimePercentageRecords) {
        //verify if there is already another period with an end date
        if (record.endDate == null && record.startDate >= this.partTimePercentage.startDate) {
          return true;
        }
      }
      return false;
    },
    isFullyOverlappingAnotherRecord() {
      if (this.partTimePercentage.endDate == null) {
        return false;
      }
      for (let record of this.partTimePercentageRecords) {
        if (record.endDate != null) {
          if (this.partTimePercentage.startDate <= record.startDate
              && this.partTimePercentage.endDate >= record.endDate) {
            return true;
          }
        }
      }
      return false;
    },
    verifyDates() {
      this.isFullyOverlappingAnotherRecord();
      const startDate = this.partTimePercentage.startDate;
      const endDate = this.partTimePercentage.endDate;
      this.isDateWrong = (endDate != null && startDate >= endDate) || startDate == null;
    },
    verifyPercentage() {
      this.isPercentageWrong =
          this.partTimePercentage.percentage == null
          || this.partTimePercentage.percentage < 0
          || this.partTimePercentage.percentage > 100;
    },
    createPartTimePercentage() {
      const createdPartTimePercentageDto = {
        percentage: this.partTimePercentage.percentage,
        startDate: this.partTimePercentage.startDate,
        endDate: this.partTimePercentage.endDate
      };
      this.createPartTimePercentageRecord(createdPartTimePercentageDto);
      this.$emit('close-create-part-time-percentage-record');
    }
  },
};
</script>

<style scoped>

.text-red {
  color: red;
}
</style>